export const enum ColorSchemes {
  LIGHT = 'light',
  DARK = 'dark',
  AUTO = 'auto'
}
